import { ReflectionsResponse } from '@api/assessmentQuestionnaireApiHandler';
import { MotionText } from '@shared/atoms';
import { NoDataBlueTraySection, SystemButton } from '@shared/molecules';
import {
  formatDateToDateFullMonthYear,
  formatDateToDateFullMonthYearWithTodayAndYesterday,
} from '@utils/date.util';
import React from 'react';
import { useHistory } from 'react-router';
import styles from './index.module.scss';

interface JournalSectionProps {
  reflections?: ReflectionsResponse[] | [];
}

export const JournalSection: React.FC<JournalSectionProps> = ({ reflections }) => {
  const history = useHistory();

  return (
    <section className={styles.journalSection} aria-labelledby="journal-heading">
      <div className={styles.journalHeader}>
        <MotionText
          className={styles.sectionTitle}
          id="journal-heading"
          as="h3"
          text="Your journal"
        />

        <SystemButton
          className={styles.journalButton}
          aria-label="Open journal"
          onClick={() => history.push('/journal')}
        >
          Journal
        </SystemButton>
      </div>

      {reflections && reflections?.length > 0 ? (
        <>
          <div className={styles.journalEntries}>
            {reflections &&
              reflections.slice(0, 2).map((entry, index) => (
                <div key={index} className={styles.journalEntry}>
                  <MotionText
                    className={styles.journalDate}
                    as="text"
                    text={
                      entry?.createdAt
                        ? formatDateToDateFullMonthYearWithTodayAndYesterday(entry?.createdAt)
                        : 'No date'
                    }
                  />

                  <MotionText
                    className={styles.journalContent}
                    as="text"
                    text={entry?.reflection || 'No reflection text'}
                  />
                </div>
              ))}
          </div>
          <a
            href="/journals"
            className={styles.viewJournalLink}
            aria-label="View your complete journal"
          >
            View your journal &gt;
          </a>
        </>
      ) : (
        <NoDataBlueTraySection text="No reflections available." />
      )}
    </section>
  );
};

JournalSection.defaultProps = {
  reflections: [],
};
